export default __webpack_public_path__ + "images/onboarding-slide-4.00b7e994dac628d64d11db176776eee0.svg";